



































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import axios from "axios";
import ModalChangeDPJP from "@/components/modal/ModalChangeDPJP.vue";
import ModalListParticipant from "@/components/modal/ModalListParticipant.vue";
import moment from "moment";
import SvcBilling from "@/services/Billing";
import EncounterIndex from "@/services/EncounterIndex";
import GlobalNotification from "@/store/modules/GlobalNotification";
import type { LabResultRecent } from "@/store/modules/GlobalNotification";
// import KepatuhanVisiteService from "@/services/KepatuhanVisiteDpjpService";
import PasienMultiWarningIndicator from "@/components/icons/PasienMultiWarningIndicator.vue";
import PasienNew from "@/services/PasienNew";
import { storePasien } from "@/store/modules/pasien";

const API_THIWUL = process.env.VUE_APP_API_THIWUL;

@Component({
  components: {
    ModalChangeDPJP,
    ModalListParticipant,
    PasienMultiWarningIndicator
  }
})
export default class CardListPasienRanap extends Vue {
  @Prop() readonly pasien!: Array<{
    register_id: number;
    pasien: {
      rm: string;
      nama: string;
    };
    dokter: {
      id: number;
    };
    raber_sp_cat: [
      {
        id: string;
        nama: string;
      }
    ];
    encounter_index: {
      participant: {
        dpjp: Array<{
          user_id: number;
          name: string;
          c_doc_id: string;
        }>;
        raber: Array<{
          user_id: number;
          name: string;
          c_doc_id: string;
        }>;
      };
      participants: {
        dpjp: Array<{
          user_id: number;
          c_doc_id: string;
          name: string;
          role: string;
          created_at: string;
        }>;
        raber: Array<{
          user_id: number;
          c_doc_id: string;
          name: string;
          role: string;
          created_at: string;
        }>;
        konsul: Array<{
          user_id: number;
          c_doc_id: string;
          name: string;
          role: string;
          created_at: string;
        }>;
      };
    };
  }>;
  @Prop() readonly poli!: {
    unit: string;
    unit_id: string;
  };
  @Prop() errListPx!: string;
  @Prop() loading!: boolean;
  status = "warning";

  dr = "";
  data = {};
  modalOpen = false;
  alertOpen = false;
  dtReg: object = {};
  page = "tab-soap";
  err: object = {};
  sess_login = this.stateuser;
  searchPx = "";
  loadingSEPReg = null;

  unitActiveId = this.poli ? this.poli["unit_id"] : null;
  isViewAllPx = false;
  // visiteCapaian: number = null;

  // async loadVisiteCapaian() {
  //   try {
  //     const now = new Date();
  //     const res = await KepatuhanVisiteService.getDashboard(now.getMonth() + 1, now.getFullYear());
  //     if (res.data && res.data.data && res.data.data.summary) {
  //       this.visiteCapaian = res.data.data.summary.capaian_persen;
  //     }
  //   } catch {
  //     // silent — tile tidak tampil jika gagal
  //   }
  // }

  get unitSibling() {
    if (["59", "60", "62", "68"].includes(this.stateuser.unit_id)) {
      return [
        {
          kode: "59",
          nama: "Pav. Yudhistira 1"
        },
        {
          kode: "60",
          nama: "Pav. Kresna 2"
        },
        {
          kode: "62",
          nama: "Pav. Kresna 1"
        },
        {
          kode: "68",
          nama: "Pav. Yudhistira 2"
        }
      ];
    } else if (["58", "71"].includes(this.stateuser.unit_id)) {
      return [
        {
          kode: "58",
          nama: "Arjuna"
        },
        {
          kode: "71",
          nama: "Bisma"
        }
      ];
    } else {
      return [];
    }
  }

  @Watch("unitActiveId")
  changeUnitActiveId(val) {
    const newUnit = this.unitSibling.find(item => item.kode == val);

    if (newUnit) {
      userModule.changeSessionUnit({
        kode: newUnit.kode,
        nama: newUnit.nama,
        unit_group_id: null,
        zona: null
      });

      this.$nextTick(() => {
        this.reloadListPx();
      });
    }
  }

  get isUnitHasSibling() {
    return this.unitSibling.length > 0;
  }

  get listPasien() {
    return this.pasien
      .filter(item => {
        const docParticipantId: Array<number> =
          item.encounter_index && item.encounter_index.participants
            ? [
                ...item.encounter_index.participants.dpjp,
                ...item.encounter_index.participants.raber,
                ...item.encounter_index.participants.konsul.filter(k => {
                  return moment().diff(moment(k.created_at), "hours") <= 24;
                })
              ].map(it => it.user_id)
            : [];
        // const spsCat: Array<string> = item.raber_sp_cat.map(kv => kv.id);

        return (
          ((userModule.isMedis &&
            (docParticipantId.includes(this.stateuser.id) ||
              item.dokter.id == this.stateuser.id)) ||
            userModule.profile?.profesi?.id == 1010101 ||
            this.isViewAllPx ||
            // view by raber spesialis
            // (this.isViewAllPx &&
            //   spsCat.includes(userModule.profile?.profesi?.id)) ||
            !userModule.isMedis) &&
          (item.pasien.nama.toLowerCase().includes(this.searchPx) ||
            item.pasien.rm.includes(this.searchPx))
        );
      })
      .map(item => {
        item["isAnyRaber"] = item?.raber_sp_cat?.length > 0;
        item["lab_result_recent"] = this.labResultRecent.find(it => {
          return item.register_id == it.register;
        });
        item["tag_indicator"] = this.getTagIndicator(item.pasien.rm);

        return item;
      });
  }

  pasienTagByRm: Record<string, Array<{ name: string }>> = {};
  pasienTagRequestSeq = 0;

  getListPasienTag(rms: Array<string>) {
    const seq = ++this.pasienTagRequestSeq;

    PasienNew.getMultiPasienTag(rms)
      .then(resp => {
        if (seq === this.pasienTagRequestSeq) {
          this.pasienTagByRm = resp;
        }
      })
      .catch(() => undefined);
  }

  getTagIndicator(rm: string): Array<string> {
    const attr = storePasien.pasientTagAttribute;
    const tags = this.pasienTagByRm[rm] ?? [];

    return tags.map(it => (attr[it.name] || attr.default).activeText);
  }

  get screen() {
    if (this.$vuetify.breakpoint.lgAndDown) return "non";
    else return "default";
  }

  get btnRefreshColor() {
    return this.errListPx == "1" ? "error" : "primary";
  }

  get headers() {
    const headers = [
      { text: "No. RM", value: "pasien.rm" },
      { text: "Nama", value: "pasien.nama", width: "20vh" },
      {
        text: "Indikator",
        value: "indikator",
        align: "center",
        sortable: false,
        width: "8vh"
      },
      { text: "Jk", value: "pasien.sex" },
      { text: "Umur (th)", value: "pasien.umur", align: "center" },
      { text: "Alamat", value: "pasien.alamat" },
      { text: "Register", value: "register_id" },
      { text: "Tgl Masuk", value: "tgl_in", width: "12vh" },
      { text: "DPJP", value: "dokter.nama" },
      // { text: "Raber", value: "encounter_index" },
      { text: "Jaminan", value: "cara_bayar.nama" },
      { text: "Kelas", value: "kelas", align: "center" },
      { text: "No. TT/ Kamar", value: "nomor", align: "center" },
      { text: "No.SEP", value: "no_sep", width: "10%" },
      { text: "Total Biaya", value: "biaya", align: "right" },
      { text: "Plafon", value: "plafon", align: "right" },
      { text: "", value: "action" }
    ];

    return headers;
  }

  get stateuser() {
    return userModule.user;
  }

  get viewAllBtnToggleColor() {
    return this.isViewAllPx ? "success" : "default";
  }

  get labResultRecent(): LabResultRecent[] {
    return GlobalNotification.labResult;
  }

  toggleViewAll() {
    this.isViewAllPx = !this.isViewAllPx;
  }

  showError(item) {
    this.alertOpen = true;
    this.err = {
      errorMsg: item,
      errorIcon: "mdi-alert-circle-outline"
    };
  }

  handleClick(item, row) {
    row.select(true);
    this.$emit("dataCM", { item: item });
  }

  reloadListPx() {
    this.$emit("reloadListPx", "0");
  }

  onParticipantChanged() {
    this.showModalChangeDpjp = false;
    this.reloadListPx();
  }

  detailRiwayat(rm) {
    this.$router.push({
      name: `detail-pasien`,
      params: {
        rm: rm
      }
    });
  }

  async goToPemeriksaan(item, page = null) {
    if (!item.encounter_index) {
      await EncounterIndex.regRanap(item.register_id, item.pasien.rm);
      // console.log("manggil postencounter", item.register_id, item.pasien.rm);
    }

    this.$router.push({
      name: `pemeriksaan-ranap`,
      params: {
        register: item.register_id,
        rm: item.pasien.rm,
        page: page
      }
    });
  }

  getPasienRelativeUmur(umur: any) {
    if (umur.th) {
      return `${umur.th} th`;
    } else if (umur.bln) {
      return `${umur.bln} bln`;
    } else {
      return `${umur.hr} hr`;
    }
  }

  async previewSepRanap(noReg) {
    this.loadingSEPReg = noReg;
    const listBerkas = await axios
      .get(`${API_THIWUL}/list-berkas/reg/${noReg}`)
      .then(dt => dt.data);

    const sep = listBerkas.data.find(item => item.id == 1102 && item.ket == 1);

    this.loadingSEPReg = null;

    if (sep && sep.link.length > 0) {
      window.open(sep.link[0], "__blank");
    } else {
      alert(
        "Berkas SEP Ranap tidak tersedia atau belum diunggah. Silahkan hubungi Admisi/ TPP..."
      );
    }
  }

  showModalChangeDpjp = false;
  dtDokter = {
    id: "",
    nama: ""
  };
  date = moment().format("YYYY-MM-DD");
  dtParticipant: object = null;

  changeDokter(item) {
    this.showModalChangeDpjp = true;
    this.dtDokter = item.dokter;
    this.dtReg = {
      register: item.register_id,
      pasienRm: item.pasien.rm,
      tgl: this.date
    };
    this.dtParticipant = item.encounter_index?.participants;
  }

  getListPasien() {
    this.$emit("reloadListPx");
  }

  billingData: null | Array<any> = null;
  loadingBillingReg = null;
  isBillingInfoModalShow = false;

  get totalTarifBilling() {
    return this.billingData?.reduce(
      (sumed, a) => sumed + parseInt(a.subtotal),
      0
    );
  }

  async showBillingRegister(regId) {
    await this.getBillingByRegister(regId);

    this.isBillingInfoModalShow = true;
  }

  async getBillingByRegister(regId) {
    this.loadingBillingReg = regId;

    const resp = await SvcBilling.getTindakanbyReg(regId)
      .then(resp => {
        return resp.data;
      })
      .finally(() => {
        this.loadingBillingReg = null;
      });

    const data = resp.sort((a, b) => {
      const tgl = new Date(a.tanggal).getTime() - new Date(b.tanggal).getTime(),
        jam =
          parseInt(a.jam.trim().padEnd(4, "0")) -
          parseInt(b.jam.trim().padEnd(4, "0"));

      return tgl || jam;
    });

    this.billingData = data;
  }

  @Watch("isBillingInfoModalShow")
  changeIsBillingInfoModalShow(val) {
    if (!val) {
      this.billingData = null;
    }
  }

  formatTarif(number) {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumSignificantDigits: 12
    }).format(number);
  }

  concatRaberText(ec) {
    let arr = [];
    if (ec) {
      arr = [...ec.participants.raber, ...ec.participants.konsul];
    }

    const rtn = arr
      .map(it => {
        return (it.role === "konsul" ? "(K) " : "") + it.name;
      })
      .join("\r\n");

    return rtn;
  }

  setDpjpText(item) {
    if (item.encounter_index?.participants?.dpjp.length > 0) {
      return item.encounter_index?.participants.dpjp[0].name;
    } else {
      return item.dokter.nama;
    }
  }

  regTotalRp: Array<{ reg: string; total: number }> = [];
  totalRpLoading = false;

  getTotalTarifAllPasien(regs: Array<number | string>) {
    this.totalRpLoading = true;

    axios
      .all(regs.map(reg => SvcBilling.getTindakanbyReg(reg)))
      .then(resp => {
        const totals = resp.map(item => {
          return {
            reg: item.data[0]?.register_id,
            total: item.data.reduce(
              (sumed, a) => sumed + parseInt(a.subtotal),
              0
            )
          };
        });

        this.regTotalRp = totals;
      })
      .finally(() => {
        this.totalRpLoading = false;
      });
  }

  plafonPasien = [];
  plafonLoading = false;

  getPlafonPasien() {
    this.plafonLoading = true;

    SvcBilling.getStatusPlafonPerUnit(this.stateuser.unit_id)
      .then(resp => {
        this.plafonPasien = resp;
      })
      .finally(() => {
        this.plafonLoading = false;
      });
  }

  // @Watch("listPasien")
  @Watch("pasien")
  changeListPasien(val, oldVal) {
    if (val.length > 0) {
      const regs = this.listPasien.map(it => it.register_id);

      this.getTotalTarifAllPasien(regs);
      this.getListPasienTag(val.map(it => it.pasien.rm));

      // Load capaian visite sekali saat pasien pertama kali dimuat
      // if (!oldVal || oldVal.length === 0) {
      //   this.loadVisiteCapaian();
      // }

      this.getPlafonPasien();

      GlobalNotification.getLabResult({unit_id: this.unitActiveId??this.sess_login.unit_id})

      // untuk netralkan notif setelah 30 minit
      setTimeout(() => {
        GlobalNotification.resetLab();
      }, 1800 * 1000);

    }
  }

  parseTotalTarif(regId) {
    const tot = this.regTotalRp.find(it => it.reg == regId)?.total ?? 0;
    return this.formatTarif(tot);
  }

  parsePlafonPasien(regId) {
    const plafon =
      this.plafonPasien.find(it => it.no == regId)?.plafon?.plafon ?? 0;
    return plafon ? this.formatTarif(plafon) : "-";
  }

  parsePlafonColor(item) {
    const tot =
        this.regTotalRp.find(it => it.reg == item.register_id)?.total ?? 0,
      plafon =
        this.plafonPasien.find(it => it.no == item.register_id)?.plafon
          ?.plafon ?? 0,
      div = plafon - tot;

    if (plafon && div > 0) {
      return "green";
    } else if (plafon && div >= -1000000) {
      return "orange";
    } else if (plafon && div < -1000000) {
      return "red";
    } else {
      return "black";
    }
  }

  mounted() {
  // Pasang listener
  this.$root.$on('reload-ranap-global', () => {
    this.reloadListPx(); // Memanggil method reload yang sudah ada di CardListPasienRanap
  });
}

// Sangat penting: Lepas listener saat komponen dihancurkan agar tidak memory leak
beforeDestroy() {
  this.$root.$off('reload-ranap-global');
}

}
